import { clearAuthCookies, setAuthCookies } from "../features/user/actions";
import jwtDecode from "jwt-decode";

import Cookies from 'universal-cookie';
const cookies = new Cookies();

// NOTE: will put all related internal/restricted // implementations here, so that we can remove them easily.

export const urlParams = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  return params;
}

export const stringUrlParams = () => {
  return window.location.search;
}

export const urlHasParameters = () => {
  const params = urlParams();
  return Object.keys(params).length !== 0
}

export const urlIsRestrictedAccess = () => {
  const params = urlParams();

  return !!params.jwt;
}

export const hasJwtTokenSet = () => {
  return !!cookies.get('jwtToken');
}

export const decodedJwt = () => {
  if (!cookies.get('jwtToken')) return;

  return jwtDecode(cookies.get('jwtToken'));
}

export const isRestrictedAccess = () => {
  if (!cookies.get('jwtToken')) return false;

  const token = jwtDecode(cookies.get('jwtToken'));
  return token.scope && token.scope !== null && token.scope !== '';
}

export const setRestrictedAccessTokenCookie = () => {
  const params = urlParams();

  if(params.jwt) {
    // Let's clear so that we are sure it is always fresh for every reload
    clearAuthCookies()

    // Set company id from token so that it will always be updated from FCC.
    const token = jwtDecode(params.jwt);
    cookies.set("companyId", token.lead_id, { path: "/" });

    setAuthCookies(params.jwt);
  }
}


// WEBPACK FOOTER //
// ./src/utils/cookies.js